export interface Subnivel {
    id?: string,
    nombre: string,
    descripcion: string
}

export const defaultSubnivel = { id: '', nombre: '', descripcion: '' };